<template>
  <div class="nav-menu" ref="navigation">
    <ul>
      <li @click="navigation('/')">
        <span :class="{selected: id == -1}">首页</span>
      </li>
      <li v-for="nav in navList" :key="nav.id + guid()">
        <a :class="{selected: nav.type == 1 && (id == nav.id || id == nav.alias)}" :href="nav.type == 1 ? `/topic/${nav.alias || nav.id}` : nav.link" target="_blank">
          {{nav.name}}
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import utils from '../../utils/index'
import ConfigService from '../../service/config.service'
export default {
  name: 'home-navgation',
  computed: {
    id () {
      const {name, meta, params} = this.$route
      return name === 'topic' ? params.id : meta.nav || 0
    }
  },
  data () {
    return {
      navList: []
    }
  },
  created () {
    this.getNavigation()
  },
  mounted () {
  },
  methods: {
    guid () {
      return utils.guid()
    },
    navigation (path) {
      this.$router.push(path)
    },
    getNavigation () {
      ConfigService.getNavList().then(res => {
        this.navList = res.top
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/common";
.nav-menu {
  position: relative;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  & ul {
    float: left;
    @extend %center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    height: 39px;
    
    & li {
      margin: 0 20px;
      color: $gray;
      word-break: keep-all;
      white-space: nowrap;

      & a {
        @include font(16, 400);
        color: $gray;
      }

      & .selected {
        position: relative;
        font-weight: 400;
        color: $blue;

        &:after {
          content: ' ';
          display: block;
          position: absolute; left: -7px; bottom: -8px; right: -7px;
          height: 2px;
          background: $blue;
          border-radius: 2px;
        }
      }
    }
  }
}
</style>
